import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex items-center justify-center min-h-screen text-[color:var(--ink-muted)]">
        A carregar…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (role) {
    const isDual = user.role === "accountant" && !!user.company_id;
    const canAccess = role === "client"
      ? (user.role === "client" || isDual)
      : user.role === "accountant";
    if (!canAccess) {
      return <Navigate to={user.role === "accountant" ? "/contabilista" : "/cliente"} replace />;
    }
  }
  return children;
}
